import { useMemo, useState } from "react"
import {
  MaterialReactTable,
  // createRow,
  useMaterialReactTable,
} from "material-react-table"
import DetalleImpresion from "../../Zonas/components/DetalleImpresion"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import { createTheme, ThemeProvider, useTheme, Box, Button, IconButton, Tooltip } from "@mui/material"
import { esES } from "@mui/material/locale"
import ImprimirIcon from "../../../assets/iconos/Impresion.ico"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import EditIcon from "@mui/icons-material/Edit"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import DeleteIcon from "@mui/icons-material/Delete"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useNavigate } from "react-router-dom"
import CrearIcon from "../../../assets/iconos/Crear.ico"
import MotivosPdf from "./MotivosPdf"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"

const CustomTable = () => {
  // para movernos a crear y editar
  const navigate = useNavigate()
  const columns = useMemo(
    () => [
      {
        accessorKey: "motcodigo",
        header: "Código",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "motdescripcion",
        header: "Descripción",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "mottipo",
        header: "Tipo",
        enableEditing: false,
        size: 80,
      },

      {
        accessorKey: "motstatus",
        header: "Estado",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          let cellValue = cell.getValue()
          if (cellValue === "A") {
            cellValue = "ACTIVO"
          } else {
            cellValue = "INACTIVO"
          }
          return cellValue
        },
      },
      {
        accessorKey: "motusuisys",
        header: "Usuario Creacion",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "motfecisys",
        header: "Fecha de Creación",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
      },
      {
        accessorKey: "mothorisys",
        header: "Hora de Creación",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return new Date(cellValue).toLocaleTimeString()
        },
      },
      {
        accessorKey: "motusumsys",
        header: "Usuario Modifica",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "motfecmsys",
        header: "Fecha Modifica",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
      },
      {
        accessorKey: "mothormsys",
        header: "Hora Modifica",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return new Date(cellValue).toLocaleTimeString()
        },
      },
    ],
    [],
  )

  const { mutateAsync: createMotivo, isPending: isCreatingMotivo } = useCreateMotivo()

  const {
    data: fetchedMotivos = [],
    isError: isLoadingMotivosError,
    isFetching: isFetchingMotivos,
    isLoading: isLoadingMotivos,
  } = useGetMotivos()
  // useUpdateZona() hook de update, ,updateZona funcion que se ejecuta
  const { mutateAsync: updateMotivo, isPending: isUpdatingMotivo } = useUpdateMotivo()
  // useDeleteZona() hook de delete , usa la funcion deleteZona()
  const { mutateAsync: deleteMotivo, isPending: isDeletingMotivo } = useDeleteMotivo()
  // funcion que muestra el modal de eliminacion
  const openDeleteConfirmModal = async (row) => {
    if (window.confirm("¿Está seguro que quiere eliminar este motivo?")) {
      await deleteMotivo(row.original.motcodigo)
    }
  }
  const table = useMaterialReactTable({
    columns,
    data: fetchedMotivos,
    enableEditing: true,
    initialState: {
      showColumnFilters: true,
    },
    enableRowActions: true,
    localization: { ...MRT_Localization_ES },
    getRowId: (row) => row.motcodigo,
    // si se cargar el error al importar los datos
    muiToolbarAlertBannerProps: isLoadingMotivosError
      ? {
          color: "error",
          children: "Error en cargar los motivos",
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Editar">
          <IconButton
            onClick={() => {
              navigate(`editar/${row?.original.motcodigo}`, {
                state: row?.original,
              })
            }}
          >
            <img src={DetalleIcon} alt="Editar" style={{ width: "20px" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <img src={EliminarIcon} alt="Grabar" style={{ width: "20px" }} />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    state: {
      isLoading: isLoadingMotivos,
      isSaving: isCreatingMotivo || isUpdatingMotivo || isDeletingMotivo,
      showAlertBanner: isLoadingMotivos,
      showProgressBars: isFetchingMotivos,
    },
  })
  return (
    <>
      <MaterialReactTable table={table} />
      <CustomBackdrop isLoading={table.getState().isSaving} />
    </>
  )
}
function useGetMotivos() {
  return useQuery({
    queryKey: ["Motivos"],
    queryFn: async () => {
      // send api request here
      let response = await fetchwrapper("/Motivos/getMotivos")
      response = await response.json()
      response = response?.data
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return response
    },
    refetchOnWindowFocus: false,
  })
}

// hooks a los que se les asigna una api y se encargan de actualizar el estado del componente
function useCreateMotivo() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (motivo) => {
      await new Promise((resolve) => setTimeout(resolve, 1000)) // fake api call
      return Promise.resolve()
    },
    onMutate: (newMotivo) => {
      queryClient.setQueryData(["Motivos"], (prevMotivos) =>
        prevMotivos?.map((prevMotivos) => (prevMotivos.motcodigo === newMotivo.motcodigo ? newMotivo : prevMotivos)),
      )
    },
  })
}
function useUpdateMotivo() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (motivo) => {
      // send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)) // fake api call
      return Promise.resolve()
    },
    // client side optimistic update
    onMutate: (newMotivoInfo) => {
      queryClient.setQueryData(["Motivos"], (prevMotivos) =>
        prevMotivos?.map((prevMotivos) =>
          prevMotivos.motcodigo === newMotivoInfo.motcodigo ? newMotivoInfo : prevMotivos,
        ),
      )
    },
  })
}
function useDeleteMotivo() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (codigoMotivo) => {
      const options = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }

      const response = await fetchwrapper(`/Motivos/deleteMotivo/${codigoMotivo}`, options)
      return response
    },
    // actualizacion optimista
    onMutate: (codigoMotivo) => {
      queryClient.setQueryData(["Motivos"], (prevMotivos) =>
        prevMotivos?.filter((motivo) => motivo.motcodigo !== codigoMotivo),
      )
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["Motivos"] })
    },
    onSuccess: () => {
      alert("Motivo eliminado con exito")
    },
    onError: () => {
      alert("No se pudo eliminar el motivo")
    },
  })
}

const DataGridMotivos = () => {
  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])
  const {
    data: fetchedMotivos = [],
    isError: isLoadingMotivosError,
    isFetching: isFetchingMotivos,
    isLoading: isLoadingMotivos,
  } = useGetMotivos()
  const handleOpenModal = () => {
    setInfoGenerada(fetchedMotivos) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }
  console.log("info pdf", fetchedMotivos)
  const handleCloseModal = () => {
    setOpenModal(false)
    navigate("/home/dashboard/Motivos")
  }
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <div>
      <Tooltip title="Crear Motivo">
        <Button color="primary" onClick={() => navigate("crear")} sx={{ marginBottom: "15px" }}>
          <img src={CrearIcon} alt="Crear" style={{ width: "30px" }} />
        </Button>
      </Tooltip>
      <Tooltip title="Imprimir">
        <Button color="primary" onClick={handleOpenModal} sx={{ marginBottom: "15px" }}>
          <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
        </Button>
      </Tooltip>
      <DetalleImpresion
        open={openModal}
        handleClose={handleCloseModal}
        infoGenerada={fetchedMotivos}
        nombrePdf={"Motivos"}
        PdfComponent={MotivosPdf}
      />
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable />
      </ThemeProvider>
    </div>
  )
}
export default DataGridMotivos
